




























import Vue from 'vue'
import { HeavyTicketsDto } from '@/Application/Expediente'
import HeavyTicketsHeader from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Execution/HeavyTicketsHeader.vue'
import HeavyTicketsRow from '@/UI/UserProcedures/WonProcedures/WonProcedureDetailTabs/Execution/HeavyTicketsRow.vue'

export default Vue.extend({
  name: 'HeavyTicketsView',
  components: { HeavyTicketsHeader, HeavyTicketsRow },
  props: {
    heavyTickets: {
      type: Object as () => HeavyTicketsDto,
      required: false
    },
    modoAlleamento: {
      type: String,
      required: true
    },
    grouped: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
